import React, { useState, useEffect } from "react";
import { Grid, TextField, Button, Container } from "@mui/material";
import { useSelector } from "react-redux";
import Header from "components/Header";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useTheme } from "@mui/material/styles";
import api from "services/api";

const getCurrentDateForInput = () => {
  const today = new Date();
  const yyyy = today.getFullYear();
  const mm = String(today.getMonth() + 1).padStart(2, '0');
  const dd = String(today.getDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
};

const ChargesFinancieres = () => {
  const theme = useTheme();
  const mode = useSelector((state) => state.global.mode);

  const [formData, setFormData] = useState({
    selectedDate: getCurrentDateForInput(),
    versement: 0,
    depensesSysteme: 0,
    depensesRxDistribution: 0,
    depensesSystemeExhaure: 0,
    total: 0,
  });

  useEffect(() => {
    setFormData((prevData) => ({
      ...prevData,
      total:
        prevData.versement +
        prevData.depensesSysteme +
        prevData.depensesRxDistribution +
        prevData.depensesSystemeExhaure,
    }));
  }, [
    formData.versement,
    formData.depensesSysteme,
    formData.depensesRxDistribution,
    formData.depensesSystemeExhaure,
  ]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === 'selectedDate') {
      setFormData((prevData) => ({
        ...prevData,
        selectedDate: value,
      }));
    } else {
      setFormData((prevData) => ({
        ...prevData,
        [name]: value === "" ? "" : Number(value),
      }));
    }
  };

  const handleFocus = (e) => {
    if (e.target.value === "0") {
      setFormData((prevData) => ({
        ...prevData,
        [e.target.name]: "",
      }));
    }
  };

  const handleBlur = (e) => {
    if (e.target.value === "") {
      setFormData((prevData) => ({
        ...prevData,
        [e.target.name]: 0,
      }));
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    const dataToSubmit = {
      ...formData,
    };

    try {
      const response = await api.post(
        "/api/chargesfinancieres",
        dataToSubmit
      );

      console.log("Form submitted:", response.data);

      toast.success("Formulaire soumis avec succès.");

      setFormData({
        selectedDate: getCurrentDateForInput(),
        versement: 0,
        depensesSysteme: 0,
        depensesRxDistribution: 0,
        depensesSystemeExhaure: 0,
        total: 0,
      });
    } catch (error) {
      console.error(
        "Erreur lors de la soumission du formulaire!",
        error
      );

      toast.error(
        "Erreur lors de la soumission du formulaire. Veuillez réessayer."
      );
    }
  };

  return (
    <Container maxWidth="lg" sx={{ mt: 2, ml: 3 }}>
      <Header
        title="Ajouter une donnée financière"
        subtitle="Les valeurs 0 sont remplies par défaut"
        sx={{ mb: 5 }}
      />
      <Grid container spacing={2} sx={{ mt: 4 }} justifyContent="center">
        <Grid item xs={8}>
          <form onSubmit={handleSubmit}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  label="Date"
                  type="date"
                  name="selectedDate"
                  value={formData.selectedDate}
                  onChange={handleChange}
                  required
                  fullWidth
                  sx={{
                    "& input::-webkit-calendar-picker-indicator": {
                      color: "darkgoldenrod",
                      filter: "invert(0.5) sepia(1) saturate(10) hue-rotate(5deg) brightness(1.1) contrast(1.2)",
                    },
                    "& input[type='date']": {
                      color: theme.palette.primary
                    }
                  }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Grid>
              {[
                "versement",
                "depensesSysteme",
                "depensesRxDistribution",
                "depensesSystemeExhaure",
                "total",
              ].map((field) => (
                <Grid item xs={6} key={field}>
                  <TextField
                    label={field.replace(/([A-Z])/g, " $1").trim()}
                    type="number"
                    name={field}
                    value={formData[field]}
                    onChange={handleChange}
                    onFocus={handleFocus}
                    onBlur={handleBlur}
                    required
                    fullWidth
                    InputProps={field === "total" ? { readOnly: true } : {}}
                    disabled={field === "total"}
                  />
                </Grid>
              ))}
              <Grid item xs={12}>
                <Button
                  type="submit"
                  variant="contained"
                  color={mode === "dark" ? "secondary" : "primary"}
                  size="large"
                  sx={{
                    width: "100%",
                  }}
                >
                  Ajouter
                </Button>
              </Grid>
            </Grid>
          </form>
        </Grid>
      </Grid>
    </Container>
  );
};

export default ChargesFinancieres;

